
<template>
    <div id="section" class="Section">
        <!-- <World/> -->
        <!-- <ThreeWorld/> -->
        <!-- <ThreeBas/> -->
        <!-- <ThreeShader/> -->
        <GlslShader/>
        <!-- <CircleShader/> -->
        <!-- <Aframe/> -->
    </div>
</template>

<script> 

import Settings from '@/config/Settings'
import Mixin from '@/mixins/Smooth.js'
import World from '@/components/World.vue'
import ThreeWorld from '@/components/ThreeWorld.vue'
import ThreeBas from '@/components/ThreeBas.vue'
import ThreeShader from '@/components/ThreeShader.vue'
import GlslShader from '@/components/GlslShader2.vue'
import CircleShader from '@/components/CircleShader.vue'
import Aframe from '@/components/Aframe.vue'

export default {
    name: 'Section',
    mixins: [Mixin],
    components: { World, ThreeWorld, ThreeBas, ThreeShader, GlslShader, Aframe, CircleShader },
}
</script>

<style lang="stylus">

@import '~@/config/Settings'

.Section 
    color black
    display flex
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh

</style>


